var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-layout"},[_c('div',{ref:"Header",staticClass:"scroll-layout-header"},[_vm._t("header")],2),_c('el-scrollbar',{ref:"scrollbar",class:{
      'scroll-layout-content': true,
      'footer-absolute': _vm.footerType === 'fixed',
    }},[_vm._t("default")],2),(_vm.showFooter)?_c('RecordNo',{staticStyle:{"position":"absolute","bottom":"0","width":"100%"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }